import { useState } from 'react';
import Cropper, { type Area } from 'react-easy-crop';

export interface ImageCropperProps {
    image: string;
    aspect?: number;
    cropShape?: 'rect' | 'round';
    onCropAreaChange: (area: Area) => void;
}

export function ImageCropper({
    image,
    aspect = 1,
    cropShape = 'round',
    onCropAreaChange,
}: ImageCropperProps) {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);

    return (
        <div className="flex flex-col gap-3">
            <div className="relative h-72 w-full overflow-hidden rounded-lg bg-grey-900">
                <Cropper
                    image={image}
                    crop={crop}
                    zoom={zoom}
                    aspect={aspect}
                    cropShape={cropShape}
                    showGrid={false}
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={(_area, areaPixels) =>
                        onCropAreaChange(areaPixels)
                    }
                />
            </div>
            <input
                type="range"
                min={1}
                max={3}
                step={0.01}
                value={zoom}
                onChange={(event) => setZoom(Number(event.target.value))}
                className="w-full accent-brand"
                aria-label="Zoom"
            />
        </div>
    );
}
